import { render, staticRenderFns } from "./facet-dropdown-minimal.vue?vue&type=template&id=3ea289f7&"
import script from "./facet-dropdown-minimal.vue?vue&type=script&lang=js&"
export * from "./facet-dropdown-minimal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports